import { formatPrice } from "domains/commons/misc";
import { Periodicity } from "domains/teams/interfaces/Pricing";

import { Text, VStack } from "@chakra-ui/react";
interface ProDiscountProps {
  periodicity: Periodicity;
}

export default function ProDiscount({ periodicity }: ProDiscountProps) {
  return (
    <VStack spacing={0.5}>
      <Text color="textPrimary" textAlign="center" size="body.bolder.md">
        ⚡ Limited Offer:{" "}
        {periodicity === "year" ? formatPrice(3_250) : formatPrice(1_500)} a
        month* ⚡
      </Text>
      <Text color="textSecondary" textAlign="center" size="body.md">
        {periodicity === "year"
          ? "for your first year!"
          : "for your first 2 months!"}
      </Text>
    </VStack>
  );
}
